import { render } from "./AiTable.vue?vue&type=template&id=ac9ffb54&scoped=true"
import script from "./AiTable.vue?vue&type=script&lang=js"
export * from "./AiTable.vue?vue&type=script&lang=js"

import "./AiTable.vue?vue&type=style&index=0&id=ac9ffb54&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac9ffb54"]])

export default __exports__